// extracted by mini-css-extract-plugin
export default {"container":"_a3737905","title":"_24d26862","issueLink":"_cc14a9b"};